// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"ProgressBar-module__progressBar___3dTJD","activeDot":"ProgressBar-module__activeDot___5_ol5","inactiveDot":"ProgressBar-module__inactiveDot___2Dw8d"};